import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';
import {DraftSortField} from 'src/openapi/admin/models/DraftSortField';
import {SortDirection} from 'src/openapi/admin/models/SortDirection';

import type {SsoAccountsFilters, SsoAccountsSearch} from '../models/typedef';
import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';

export const ssoAccountsStateSlice = getCachedTableStateSlice<
    SsoAccountsSearch,
    DraftSortField,
    SsoAccountsFilters
>('ssoAccountsState', DraftSortField.CREATED_AT, undefined, SortDirection.DESC);

export const ssoAccountsStateActions = ssoAccountsStateSlice.actions;
export const ssoAccountsStateSelector: CachedTableStateSelector<
    SsoAccountsSearch,
    DraftSortField,
    SsoAccountsFilters
> = state => state.ssoAccounts.state;
